"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Lifetime;
(function (Lifetime) {
    Lifetime["SINGLETON"] = "singleton";
    Lifetime["TRANSIENT"] = "transient";
    Lifetime["SCOPED"] = "scoped";
})(Lifetime || (Lifetime = {}));
exports.default = Lifetime;
//# sourceMappingURL=Lifetime.js.map